var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0388 18.566C17.9537 18.83 17.7054 19.0066 17.4284 18.9998C16.2259 18.9755 12.886 18.5378 9.17409 14.8263C5.4616 11.1137 5.02473 7.77297 5.00016 6.57041C4.99384 6.29379 5.1702 6.0463 5.43378 5.96089L8.28298 5.03105C8.60132 4.92914 8.94486 5.08542 9.07736 5.39212L10.2149 8.02728C10.3203 8.26604 10.2686 8.54556 10.0846 8.73095L8.74916 10.0665C8.66158 10.1529 8.63301 10.2829 8.67609 10.3984C9.07589 11.535 9.73403 12.5629 10.5987 13.4014C11.437 14.2653 12.4647 14.9243 13.6007 15.3242C13.7164 15.3669 13.8467 15.3387 13.9338 15.2504L15.2687 13.9159C15.4545 13.7314 15.734 13.68 15.9734 13.7858L18.6077 14.9224C18.9143 15.0553 19.0706 15.3979 18.9692 15.7163L18.0388 18.566Z",
    fill: "#E0E1EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7b8bfde5.svg";
export { ForwardRef as ReactComponent };